import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./Components/Invoice/InvoiceStyle.css";
import ActivityLog from "./Components/ActivityLog";
import EmployeePerformance from "./Components/EmployeePerformance";
import Salaries from "./Components/Salaries";
import Leads from "./Components/Leads";
import Dashboard from "./Components/Dashboard2/Dashboard";
import ReceivedPayment from "./Components/ReceivedPayment";
import DuePayment from "./Components/DuePayment";
import Offerings from "./Components/Offering";
import AllUsers from "./Components/AllUsers";
import UserRecords from "./Components/UserRecords";
import ClassAgeGroup from "./Components/ClassAgeGroup";
import ClassLevels from "./Components/ClassLevels";
import ClassSchedule from "./Components/ClassSchedule";

import Branch from "./Components/Branch";
import Updates from "./Components/Updates";
import Equipments from "./Components/Equipments";
import Renewals from "./Components/Renewals";
import Category from "./Components/Category";
import Pincode from "./Components/Pincode";
import Delivery from "./Components/Delivery";
import Coupon from "./Components/Coupon";
import Orders from "./Components/Orders";
import Location from "./Components/Location";
import AddTimeLog from "./Components/AddTimeLog";
import TimeLog from "./Components/TimeLog";
import SalaryDetail from "./Components/SalaryDetail";
import Gallery from "./Components/Gallery";
import Login from "./Components/Login";
import UserRecordSuper from "./Components/UserRecordSuper";
import { ToastContainer } from "react-toastify";
import Attributes from "./Components/Attribute";
import Terms from "./Components/Terms/Terms";
import SimpleProduct from "./Components/Equipments/SimpleProduct";
import SimpleProductEdit from "./Components/Equipments/SimpleProductEdit";
import AffiliateProduct from "./Components/Equipments/AffiliateProduct";
import GroupedProduct from "./Components/Equipments/GroupedProduct";
import VariableProduct from "./Components/Equipments/VariableProduct";
import VariableProductEdit from "./Components/Equipments/VariableProductEdit";
import AffiliateProductEdit from "./Components/Equipments/AffiliateProductEdit";
import GroupedProductEdit from "./Components/Equipments/GroupedProductEdit";
import Unit from "./Components/Units/Unit";
import OrderUpdatedVersion from "./Components/LeadsUpdatedVersion/OrderUpdatedVersion";
import {
  getDecryptedUserFromCookie,
  getSessionMainId,
} from "./Components/utils/getCookie";
import axios from "axios";
import {
  listenToForegroundMessages,
  requestFCMToken,
} from "./Components/utils/firebaseUtils";
import Customer from "./Components/CustomerDetails/Customer";
import ProtectedRoute from "./Components/ProtectedRoute";
import SkatesAdmissionRoute from "./Components/SkatesAdmissionRoute";
import CustomerImport from "./Components/CustomerDetails/CustomerImport";
import Export from "./Components/Invoice/export";
import IndividualInvoice from "./Components/Invoice/IndiviualInvoice";
import NewInvoice from "./Components/Invoice/NewInvoice";
import InvoiceImport from "./Components/Invoice/InvoiceImport";
import InvoicePdf from "./Components/Invoice/InvoicePdf";
import ExportCustomer from "./Components/CustomerDetails/exportcustomer";
import AddCustomer2 from "./Components/CustomerDetails/AddCustomer2";
import AddCustomer3 from "./Components/CustomerDetails/AddCustomer3";
import Expenses from "./Components/Expense/IndividualExpenses";
import ScrollToTop from "./Components/ScrollToTop";
import CRMUpdatedVersion from "./Components/CRMUpdatedVersion/CRMUpdatedVersion";
import Slider from "./Components/Slider/Slider";
import NewArrivals from "./Components/NewArrivals/NewArrivals";
import Offer from "./Components/Offer/Offer";
import Setting from "./Components/Setting/Setting";
import Marquee from "./Components/Marquee/Marquee";
import ExportExpense from "./Components/Expense/exportExpense";
import ExpenseImport from "./Components/Expense/ExpenseImport";
import CustomerDetail from "./Components/CustomerDetails/CustomerDetail";
import InvoiceDetail from "./Components/Invoice/InvoiceDetail";
import ExpenseDetail from "./Components/Expense/ExpenseDetail";
import EquipmentsDetail from "./Components/EquipmentsDetail";
import SettingUpdated from "./Components/SettingUpdated/SettingUpdated";
import ResetPassword from "./Components/ResetPassword";
import CategoryMain from "./Components/Category/CategoryMain";
import Admission from "./Components/Admission/Admission";
import AdmissionDetail from "./Components/Admission/AdmissionDetail";
import AdmissionImport from "./Components/Admission/AdmissionImport";
import ExportAdmission from "./Components/Admission/exportadmission";
import AddAdmission2 from "./Components/Admission/AddAdmission2";
import AddAdmission3 from "./Components/Admission/AddAdmission3";
import AdmissionCentersSettings from "./Components/Admission/AdmissionCentersSettings";
import AdmissionBatches from "./Components/Admission/AdmissionBatches";
import AdmissionBatchEditor from "./Components/Admission/AdmissionBatchEditor";
import StudentAttendance from "./Components/Admission/StudentAttendance";
import Receipt from "./Components/Receipt";
import OrderCharts from "./Components/OtherCarts/OrderCharts";
import HelpAndSupport from "./Components/HelpAndSupport";
import { jwtDecode } from "jwt-decode";
import { decryptToken } from "./Components/utils/getToken";
import Integration from "./Components/Integrations/Integration";
import EmployeeProfile from "./Components/Team/EmployeeProfile";
import NewStaff from "./Components/Team/NewStaff";
import Onboarding from "./Components/Onboarding/Onboarding";
import CareerFormWithJobs from "./Components/Onboarding/CareerFormWithJob";
import CreateJob from "./Components/Onboarding/CreateJob";
import Task from "./Components/Task/Task";
import Department from "./Components/Department/Department";
import TeamDirectory from "./Components/Team/TeamDirectory";
import TeamAttendance from "./Components/Team/TeamAttendance";
import TaskHistoryPage from "./Components/Task/TaskHistoryPage";
import Menus from "./Components/Menus/Menus";
import Refer from "./Components/Referral/Refer";
import ReferUsage from "./Components/Referral/ReferUsage";
import WalletTarget from "./Components/Wallet/WalletTarget";
import Testimonials from "./Components/Testimonial/Testimonial";
import Blogs from "./Components/Blog/Blog";
import Brand from "./Components/Brand/Brand";
import MediaLibraryPage from "./Components/Media/MediaLibrary";
import Plan from "./Components/Plan/Plan";
import UserForm from "./Components/UserFormSuper";
import BusinessCategory from "./Components/BusinessCategory/BusinessCategory";
import CallToActionSection1 from "./Components/CallToActionSection1/CallToActionSection1";
import ProductAi from "./Components/ProductsAi/ProductsAi";

import ProductHistory from "./Components/ProductsAi/ProductHistory";
import CustomerHistory from "./Components/LeadsUpdatedVersion/CustomerHistory";
import BadDebt from "./Components/Invoice/BadDebt";
import MainLayout from "./Layout/MainLayout";
import CRMAnalytics from "./Components/CRMAnalytics/CRMAnalytics";
import Invoice from "./Components/Invoice/Invoice";
import IndividualExpenses from "./Components/Expense/IndividualExpenses";
import Expense from "./Components/Expense/Expense";
import ReceiptIndividual from "./Components/ReceiptIndividual";
import CRMMessage from "./Components/CRMUpdatedVersion/CRMMessage";
import Task2 from "./Components/Task2/Task";
import FooterSetting from "./Components/Footer/FooterSetting";
import TrackSlider from "./Components/TrackSlider/TrackSlider";
import CallToActionSection2 from "./Components/CallToActionSection2/CallToActionSection2";
import Review from "./Components/Reviews/Review";
import CallToActionTable from "./Components/CallToAction/CallToActionTable";
import WalletHistory from "./Components/Wallet/WalletHistory";
import WalletUserHistory from "./Components/Wallet/WalletUserHistory";
import FaqAdmin from "./Components/Faq/FaqAdmin"
import CatlogCategory from "./Components/Catlog/CatlogCategory";
import Catlog from "./Components/Catlog/Catlog";
import UserActivityLog from "./Components/UserActivity";
import AddBlog from "./Components/Blog/AddBlog";
import AllBlogs from "./Components/Blog/AllBlogs";
import EditBlog from "./Components/Blog/EditBlog";
import Author from "./Components/Blog/Author";
import Categories from "./Components/Blog/Categories";
import AdminBlogDetail from "./Components/Blog/AdminPreview";
import AllCommentsPage from "./Components/Blog/AllCommentsPage";
import AdminBlogComments from "./Components/Blog/AdminBlogComment";
import HeroSection from "./Components/HeroSection";
import ProductBanner from "./Components/ProductBanner/ProductBanner";

axios.interceptors.request.use((config) => {
  const t = decryptToken("accessToken");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

function App() {
  const location = useLocation();
  const token = decryptToken("accessToken");
  const url = API_BASE_URL;
  const userData = getDecryptedUserFromCookie();
  const sessionMainId = getSessionMainId();
  const userLoggedIn = !!sessionMainId;
  const [totalnewOrder, setTotalnewOrder] = useState();
  const fetchOrderData = async () => {
    const authToken = decryptToken("accessToken");
    if (!authToken) return;

    try {
      const response = await fetch(`${url}/payment/ordercheck/status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const res = await response.json();

      // ────────────────────────────────
      // 1. LOG RAW RESPONSE
      // ────────────────────────────────
      console.log("Raw API Response:", res);

      // ────────────────────────────────
      // 2. EXTRACT & LOG ORDERS ARRAY
      // ────────────────────────────────
      const orders = res.orders || res.data || []; // adjust key if needed
      console.log("Orders Array (raw):", orders);
      console.log("Total Orders Received:", orders.length);

      // ────────────────────────────────
      // 3. PARSE NESTED JSON STRINGS SAFELY
      // ────────────────────────────────
      const safeParse = (str) => {
        if (typeof str !== "string") return str;
        try {
          return JSON.parse(str);
        } catch (e) {
          console.warn("Failed to parse JSON string:", str);
          return str; // fallback
        }
      };

      const parsedOrders = orders.map((order, idx) => {
        const parsed = {
          ...order,
          cart_products: safeParse(order.cart_products),
          shipping_address: safeParse(order.shipping_address),
          billing_address: safeParse(order.billing_address),
        };

        // Log first 3 orders in detail
        if (idx < 3) {
          console.log(`Order #${idx + 1}:`, parsed);
        }

        return parsed;
      });

      // ────────────────────────────────
      // 4. LOG TOTAL NEW ORDERS
      // ────────────────────────────────
      const totalNew = res.totalNewOrders ?? 0;
      console.log("Total New Orders (from API):", totalNew);

      // ────────────────────────────────
      // 5. UPDATE STATE
      // ────────────────────────────────
      setTotalnewOrder(totalNew);

      // Optional: return parsed data if needed elsewhere
      return { orders: parsedOrders, totalNewOrders: totalNew };
    } catch (error) {
      console.error("fetchOrderData failed:", error);
      // Optional: set error state
    } finally {
      // Optional: set loading false
    }
  };
  const fetchData = async () => {
    const authToken = decryptToken("accessToken");
    const mainId = getSessionMainId();
    if (!mainId || !authToken) return;

    try {
      const response = await axios.get(
        `${url}/register/single/${mainId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // setProfile(response.data);
      localStorage.setItem(
        "2xgxgshdugyywerw12gh",
        JSON.stringify(response.data.users)
      );
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const [fcmToken, setfcmToeken] = useState(null);

  useEffect(() => {
    const fetchFcmToken = async () => {
      try {
        const token = await requestFCMToken();

        setfcmToeken(token);
      } catch (error) {
        console.error("error getting token ", error);
      }
    };
    fetchFcmToken();
    listenToForegroundMessages();
  }, []);

  useEffect(() => {
    if (!fcmToken || !userLoggedIn) return;
    const uid = getSessionMainId();
    if (!uid) return;
    const saveToken = async () => {
      try {
        await axios.post(`${url}/firebase/register-token`, {
          user_id: uid,
          deviceToken: fcmToken,
        });
      } catch (error) {
        console.error("Failed to save FCM token:", error);
      }
    };
    saveToken();
  }, [fcmToken, userLoggedIn]);

  function logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("2xgxgshdugyywerw12eccom");
    localStorage.removeItem("2xgxgshdugyywerw12gh");
    window.location.href = "/login";
  }

  function checkTokenOnLoad() {
    const token = decryptToken("accessToken");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        logout(); // token expired
      } else {
        const timeUntilExpiry = decoded.exp * 1000 - Date.now();
        setTimeout(() => {
          logout();
        }, timeUntilExpiry);
      }
    } catch (err) {
      logout();
    }
  }

  useEffect(() => {
    checkTokenOnLoad();
  }, []);

  useEffect(() => {
    if (!userLoggedIn || !token) return;
    fetchData();
    fetchOrderData();
  }, [userLoggedIn, token]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout totalnewOrder={totalnewOrder} />}>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer"
            element={
              <ProtectedRoute>
                <Customer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <Admission />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-attendance"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <StudentAttendance />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-detail/:id"
            element={
              <ProtectedRoute>
                <CustomerDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission-detail/:id"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AdmissionDetail />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice-detail/:id"
            element={
              <ProtectedRoute>
                <InvoiceDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/expense-detail/:id"
            element={
              <ProtectedRoute>
                <ExpenseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-detail/:id"
            element={
              <ProtectedRoute>
                <EquipmentsDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-import"
            element={
              <ProtectedRoute>
                <CustomerImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/export"
            element={
              <ProtectedRoute>
                <Export />
              </ProtectedRoute>
            }
          />
          <Route
            path="/export-expense"
            element={
              <ProtectedRoute>
                <ExportExpense />
              </ProtectedRoute>
            }
          />
          <Route
            path="/import-expense"
            element={
              <ProtectedRoute>
                <ExpenseImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/individual-invoice/:id"
            element={
              <ProtectedRoute>
                <IndividualInvoice />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/invoice"
            element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bad-debt"
            element={
              <ProtectedRoute>
                <BadDebt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-invoice"
            element={
              <ProtectedRoute>
                <NewInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/integrations"
            element={
              <ProtectedRoute>
                <Integration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice-import"
            element={
              <ProtectedRoute>
                <InvoiceImport />{" "}
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice-pdf/:order_number"
            element={
              <ProtectedRoute>
                {" "}
                <InvoicePdf />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-invoice/:id"
            element={
              <ProtectedRoute>
                <NewInvoice isEditMode={true} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/export-customer"
            element={
              <ProtectedRoute>
                <ExportCustomer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/export-admission"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <ExportAdmission />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission-import"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AdmissionImport />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission-centers-settings"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AdmissionCentersSettings />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-customer"
            element={
              <ProtectedRoute>
                <AddCustomer2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-customer"
            element={
              <ProtectedRoute>
                <AddCustomer3 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-admission"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AddAdmission2 />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-admission"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AddAdmission3 />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission-batches"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AdmissionBatches />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admission-batches/:batchId"
            element={
              <ProtectedRoute>
                <SkatesAdmissionRoute>
                  <AdmissionBatchEditor />
                </SkatesAdmissionRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/expense"
            element={
              <ProtectedRoute>
                <Expense />
              </ProtectedRoute>
            }
          />
          <Route
            path="/individual-expense"
            element={
              <ProtectedRoute>
                <IndividualExpenses />
              </ProtectedRoute>
            }
          />
          <Route path="/activity-log" element={<ActivityLog />} />
          <Route path="/time-log" element={<TimeLog />} />
          <Route path="/performance" element={<EmployeePerformance />} />
          <Route path="/salary" element={<Salaries />} />
          <Route
            path="/crm"
            element={
              <ProtectedRoute>
                <CRMUpdatedVersion />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crm-message"
            element={
              <ProtectedRoute>
                <CRMMessage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crm-analytics"
            element={
              <ProtectedRoute>
                <CRMAnalytics />
              </ProtectedRoute>
            }
          />
          <Route path="/received-payment" element={<ReceivedPayment />} />
          <Route path="/due-payment" element={<DuePayment />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route
            path="/all-users"
            element={
              <ProtectedRoute>
                <AllUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-records"
            element={
              <ProtectedRoute>
                <UserRecords />
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity/:id"
            element={
              <ProtectedRoute>
                <UserActivityLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alluser-records"
            element={
              <ProtectedRoute>
                <UserRecordSuper />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-blog"
            element={
              <ProtectedRoute>
                <AddBlog />
              </ProtectedRoute>
            }
          />
           <Route
            path="/edit-blog/:id"
            element={
              <ProtectedRoute>
                <EditBlog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/author"
            element={
              <ProtectedRoute>
                <Author />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog-category"
            element={
              <ProtectedRoute>
                <Categories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog"
            element={
              <ProtectedRoute>
                <AllBlogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-form"
            element={
              <ProtectedRoute>
                <UserForm />
              </ProtectedRoute>
            }
          />
          <Route path="/age-group" element={<ClassAgeGroup />} />
          <Route path="/class-level" element={<ClassLevels />} />
          <Route path="/class-schedule" element={<ClassSchedule />} />

          <Route path="/team-directory" element={<TeamDirectory />} />
          <Route path="/team-attendance" element={<TeamAttendance />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/branch" element={<Branch />} />
          <Route path="/updates" element={<Updates />} />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Equipments />
              </ProtectedRoute>
            }
          />
          <Route path="/renewals" element={<Renewals />} />
          <Route
            path="/category"
            element={
              <ProtectedRoute>
                <Category />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-category"
            element={
              <ProtectedRoute>
                <BusinessCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pincode"
            element={
              <ProtectedRoute>
                <Pincode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/delivery"
            element={
              <ProtectedRoute>
                <Delivery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coupon"
            element={
              <ProtectedRoute>
                <Coupon />
              </ProtectedRoute>
            }
          />
          <Route
            path="/slider"
            element={
              <ProtectedRoute>
                <Slider />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrival"
            element={
              <ProtectedRoute>
                <NewArrivals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offer"
            element={
              <ProtectedRoute>
                <Offer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setting"
            element={
              <ProtectedRoute>
                <SettingUpdated />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setting1"
            element={
              <ProtectedRoute>
                <SettingUpdated />
              </ProtectedRoute>
            }
          />
          <Route
            path="/headline"
            element={
              <ProtectedRoute>
                <Marquee />
              </ProtectedRoute>
            }
          />
          <Route
            path="/receipt"
            element={
              <ProtectedRoute>
                <Receipt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/individual-receipt/:id"
            element={
              <ProtectedRoute>
                <ReceiptIndividual />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/orders" element={<Orders />} /> */}
          <Route path="/login" element={<Login />} />
          <Route
            path="/home/login"
            element={
             
                <HeroSection />
              
            }
          />
          <Route path="/reset" element={<ResetPassword />} />
          {/* <Route path="/register" element={<Register />} /> */}

          <Route path="/location" element={<Location />} />
          <Route path="/salary-detail" element={<SalaryDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route
            path="/features"
            element={
              <ProtectedRoute>
                <Attributes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/terms/:id"
            element={
              <ProtectedRoute>
                <Terms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/simple-product"
            element={
              <ProtectedRoute>
                <SimpleProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/external-affiliate-product"
            element={
              <ProtectedRoute>
                <AffiliateProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grouped-product"
            element={
              <ProtectedRoute>
                <GroupedProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/variable-product"
            element={
              <ProtectedRoute>
                <VariableProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/variableedit-product/:id"
            element={
              <ProtectedRoute>
                <VariableProductEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/simple-productedit/:id"
            element={
              <ProtectedRoute>
                <SimpleProductEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/affiliate-productedit/:id"
            element={
              <ProtectedRoute>
                <AffiliateProductEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grouped-productedit/:id"
            element={
              <ProtectedRoute>
                <GroupedProductEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/unit"
            element={
              <ProtectedRoute>
                <Unit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrderUpdatedVersion fetchOrderData={fetchOrderData} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category-main"
            element={
              <ProtectedRoute>
                <CategoryMain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comment"
            element={
              <ProtectedRoute>
                <AdminBlogComments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/preview-blog/:slug/:id"
            element={
              <ProtectedRoute>
                <AdminBlogDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-charts"
            element={
              <ProtectedRoute>
                <OrderCharts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-directory"
            element={
              <ProtectedRoute>
                <TeamDirectory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-attendance"
            element={
              <ProtectedRoute>
                <TeamAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-profile/:id/:name"
            element={
              <ProtectedRoute>
                <EmployeeProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-staff"
            element={
              <ProtectedRoute>
                <NewStaff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/faq"
            element={
              <ProtectedRoute>
                <FaqAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/career"
            element={
              <ProtectedRoute>
                <CareerFormWithJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/footer-setting"
            element={
              <ProtectedRoute>
                <FooterSetting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <CreateJob />
              </ProtectedRoute>
            }
          />
          <Route
            path="/track-slider"
            element={
              <ProtectedRoute>
                <TrackSlider />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tasks"
            element={
              <ProtectedRoute>
                <Task />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tasks-2"
            element={
              <ProtectedRoute>
                <Task2 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/department"
            element={
              <ProtectedRoute>
                <Department />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <TaskHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/menus"
            element={
              <ProtectedRoute>
                <Menus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/refer"
            element={
              <ProtectedRoute>
                <Refer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/refer-usage"
            element={
              <ProtectedRoute>
                <ReferUsage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet-target"
            element={
              <ProtectedRoute>
                <WalletTarget />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonial"
            element={
              <ProtectedRoute>
                <Testimonials />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog"
            element={
              <ProtectedRoute>
                <Blogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brand"
            element={
              <ProtectedRoute>
                <Brand />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productbanner"
            element={
              <ProtectedRoute>
                <ProductBanner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute>
                <MediaLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan"
            element={
              <ProtectedRoute>
                <Plan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/herosection"
            element={
              <ProtectedRoute>
                <HeroSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calltoaction-form"
            element={
              <ProtectedRoute>
                <CallToActionTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calltoactionfirst"
            element={
              <ProtectedRoute>
                <CallToActionSection1 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calltoactionsecond"
            element={
              <ProtectedRoute>
                <CallToActionSection2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet-history"
            element={
              <ProtectedRoute>
                <WalletHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet-history/:id/:name"
            element={
              <ProtectedRoute>
                <WalletUserHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/review"
            element={
              <ProtectedRoute>
                <Review />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-ai"
            element={
              <ProtectedRoute>
                <ProductAi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-history"
            element={
              <ProtectedRoute>
                <ProductHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catlog-catgeory"
            element={
              <ProtectedRoute>
                <CatlogCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catlog"
            element={
              <ProtectedRoute>
                <Catlog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-history/:id"
            element={
              <ProtectedRoute>
                <CustomerHistory />
              </ProtectedRoute>
            }
          />
          <Route path="/help-support" element={<HelpAndSupport />} />
        </Route>
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ zIndex: 999999 }}
      />
    </>
  );
}

export default App;
